import { createQuery } from "@/api/utils/createQuery";
import { Draft, DraftSnapshot } from "./Draft.model";
import { FileSnapshot } from "./File.model";
import { parseDraft } from "./dummies/DataAssociation.parsers";
import { Account, AccountLabel } from "./Account.model";
import { QueryStringBuilder } from "@/utils";

export const getFile = createQuery<FileSnapshot, { fileId: string }>(
    async ({ api, params }) => {
        const response = await api.get(
            `/data-association/files/${params.fileId}`,
        );

        return response;
    },
);

export const getFiles = createQuery<FileSnapshot[]>(async ({ api, router }) => {
    const response = await api.get(
        `/data-association/files?company_id=in.("${router.params.companyId}")`,
    );

    return response.items;
});

export const getDraftPreview = createQuery<Draft>(async ({ api, router }) => {
    const response = await api.get(
        `/data-association/files/${router.params.fileId}/draft`,
    );

    return parseDraft(response);
});

export const getDraft = createQuery<Draft>(async ({ api, router }) => {
    const response = await api.get(
        `/data-association/files/${router.params.fileId}/drafts/${router.params.draftId}`,
    );

    return parseDraft(response);
});

export const getDrafts = createQuery<DraftSnapshot[]>(
    async ({ api, router }) => {
        const response = await api.get(
            `/data-association/drafts?company_id=in.("${router.params.companyId}")`,
        );

        return response.items;
    },
);

export const getAccounts = createQuery<
    Account[],
    { labels?: AccountLabel[]; accountNames?: string[] }
>(async ({ api, router, params }) => {
    let querystring = "";
    if (params?.labels || params?.accountNames) {
        querystring =
            "&" +
            new QueryStringBuilder()
                .in("label", params.labels)
                .in("name", params.accountNames)
                .build();
    }
    const response = await api.get(
        `/data-association/accounts?company_id=in.("${router.params.companyId}")${querystring}`,
    );

    return response.items;
});
